import validateLoadInput from 'utils/loads/validators/validateLoadInput';
import validateLoad from 'utils/loads/validators/validateLoad';

export default {
  validateLoad,
  validateLoadInput,
};
